import React, { useState, useEffect } from 'react'
import api from '../components/api'


const Modal = (props) => {

    //var [barraLateral_id, setBarraLateral_id] = useState(props.barraLateral_id)
    var barraLateral_id = props.barraLateral_id
    var pagina_id = props.pagina_id


    var [titulo, setTitulo] = useState('')
    var [topico, setTopico] = useState('')
    var [tipoLink, setTipoLink] = useState('')
    var [link, setLink] = useState('')
    var [pagina_id_link, setPagina_id_link] = useState('')
    
    var [paginas, setPaginas] = useState()

    async function salva() {


        if (titulo == '') {

            window.toastr.error('<b>Título</b> não pode ficar em branco!')
            return false

        }

        if (topico == '') {

            window.toastr.error('<b>Tópico</b> não pode ficar em branco!')
            return false

        }

        if (tipoLink == '') {

            window.toastr.error('<b>Tipo Link</b> não pode ficar em branco!')
            return false

        }

        
        var dataPost = {

            titulo: titulo,
            topico: topico,
            tipoLink: tipoLink,
            link: link,
            pagina_id_link: pagina_id_link,

        }

        //console.log(dataPost)
        //return false


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma salvar?',
		    buttons: {
		        Sim: function () {

                    //console.log(dataPost)

                    if (barraLateral_id) {

                        api.put(`barraLateral/${barraLateral_id}`, dataPost).then((result) => {

                            //console.log(result.data)
                            props.carregaBarraLateral()
                            window.$("#modalBarraLateral").modal('hide');
                            //setBarraLateral_id(result.data[0].barraLateral_id)
                            window.toastr.success('Registro salvo com sucesso!')
                            
                        }).catch((err) => {

                            console.log(err.response)

                        })


                    } else {

                        api.post(`barraLateral/${pagina_id}`, dataPost).then((result) => {

                            console.log(result.data)
                            props.carregaBarraLateral()
                            window.$("#modalBarraLateral").modal('hide');
                            window.toastr.success('Registro salvo com sucesso!')
                            

                        }).catch((err) => {

                            console.log(err.response)

                        })

                    }
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


    }


    function carregaDados() {

        setTitulo('')
        setTopico('')
        setLink('')
        setTipoLink('')
        setPagina_id_link('')
        

        if (barraLateral_id) {

            api.get(`barraLateralDetalhe/${barraLateral_id}`).then((result) => {

                console.log(result.data)
                var data = result.data[0]

                if (data) {

                    setTitulo(data.titulo)
                    setTopico(data.topico)
                    setLink(data.link)
                    setTipoLink(data.tipoLink)
                    setPagina_id_link(data.pagina_id_link)

                }
                

            }).catch((err) => {

                console.log(err.response)

            })

        }

        
    }


    async function carregaPaginas() {


        api.get('paginasCategorias').then((result) => {

            //console.log(result.data)
            setPaginas(result.data.map((rs) =>
            
                <option value={rs.pagina_id}>{rs.identificacao}</option>

            ))

        }).catch((err) => {

            console.log(err.response)

        })

    }


    function apaga() {

        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'red',
		    title: 'Confirmação',
		    content: 'Confirma apagar?',
		    buttons: {
		        Sim: function () {

                    //console.log(dataPost)

                    api.delete(`barraLateral/${barraLateral_id}`).then((result) => {

                        //console.log(result.data)
                        props.carregaBarraLateral()
                        window.$("#modalBarraLateral").modal('hide');
                        //setBarraLateral_id(result.data[0].barraLateral_id)
                        window.toastr.success('Apagado com sucesso!')

                    }).catch((err) => {

                        console.log(err)

                    })
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });

    }


    useEffect(() => {


        carregaDados()
        carregaPaginas()
                
        
    }, [barraLateral_id])


    return (

        <div>


                <div className="modal fade" id="modalBarraLateral" tabindex="-1" role="dialog">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Barra Lateral</h1>
                            </div>
                            <div class="modal-body">
                                    
                                    <div class="panel-body">
                                        
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>Título</label>
                                                <input type="text" class="form-control" placeholder="" value={titulo} onChange={event => setTitulo(event.target.value)} />
                                                                
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>Tópico</label>
                                                <input type="text" class="form-control" placeholder="Agrupamento do link" value={topico} onChange={event => setTopico(event.target.value)} />
                                                                
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>Tipo link</label>
                                                <select class="form-control" value={tipoLink} onChange={event => setTipoLink(event.target.value)}>
                                                    <option value="">[Selecione]</option>
                                                    <option value="I">Interno</option>
                                                    <option value="E">Externo</option>
                                                </select>
                                                                
                                            </div>
                                        </div>

                                        
                                        <div class="col-md-12" style={{ display: tipoLink == 'E' ? 'table-row' : 'none'}}>
                                            <div class="form-group">
                                                <label>Link externo</label>
                                                <input type="text" class="form-control" placeholder="Por favor, informe o https:// antes do link..." value={link} onChange={event => setLink(event.target.value)} />
                                                                
                                            </div>
                                        </div>


                                        <div class="col-md-12" style={{ display: tipoLink == 'I' ? 'table-row' : 'none'}}>
                                            <div class="form-group">
                                                <label>Página</label>
                                                <select class="form-control" value={pagina_id_link} onChange={event => setPagina_id_link(event.target.value)}>
                                                    <option value="">[Selecione]</option>
                                                    {paginas}
                                                </select>
                                                                
                                            </div>
                                        </div>



                                    </div>


                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                <button style={{ display: barraLateral_id ? 'table-row' : 'none'}} type="button" className="btn btn-danger" onClick={() => apaga()}>Apagar</button>
                                <button type="button" className="btn btn-success" onClick={() => salva()}>Salvar</button>
                            </div>
                        </div>
                    </div>
                </div>

        </div>


    )

}


export default Modal
